import React, { useState, useEffect } from 'react';
import { dateFormatConDiaShort } from '../../../../../utils/DateFunctions';
import v from '../../../../../utils/Verifiers';
const NominasPorDia = (p) => {
    const reportes = p.reportes ?? { datos: [], fechas: [], grupos: [], supervisores: [] };
    const [indexDetalles, setindexDetalles] = useState(-1);
    const [reporteDias, setreporteDias] = useState([]);

    useEffect(() => {
        setindexDetalles(-1);
        reporteDiasMaker();
    }, [p.reportes]);

    const colorAvance = (porcentajeAvance) => {
        if (porcentajeAvance < 50) return '#a91f00';
        if (porcentajeAvance < 80) return '#c36b00';
        if (porcentajeAvance < 90) return '#76a800';
        if (porcentajeAvance > 100) return '#005a70';
        return '#008000';
    }

    const reporteDiasMaker = () => {
        const repSup = {}
        const len = reportes.datos.length;
        for (let i = 0; i < len; i++) {
            const d = reportes.datos[i];
            if (!repSup.hasOwnProperty(d.fecha_asignacion)) {
                repSup[d.fecha_asignacion] = {
                    fecha_asignacion: d.fecha_asignacion,
                    ordenes: [],
                    tiempo_asignado: 0,
                    tiempo_realizado: 0,
                    unidades_asignadas: 0,
                    unidades_realizadas: 0,
                    empleados: {},
                    supervisores: {},
                }
            }
            repSup[d.fecha_asignacion].ordenes.push(d);
            repSup[d.fecha_asignacion].tiempo_asignado += d.unidades_asignadas * d.ms_por_unidad / 3600000;
            repSup[d.fecha_asignacion].tiempo_realizado += d.unidades_realizadas * d.ms_por_unidad / 3600000;
            repSup[d.fecha_asignacion].unidades_asignadas += d.unidades_asignadas;
            repSup[d.fecha_asignacion].unidades_realizadas += d.unidades_realizadas;
            repSup[d.fecha_asignacion].empleados[d.asignado_a_id] = true;
            repSup[d.fecha_asignacion].supervisores[d.asignado_por_id] = true;
        }
        console.log("repSup", repSup);
        const rep = Object.values(repSup);
        rep.sort((a, b) => Date.parse(a.fecha_asignacion) - Date.parse(b.fecha_asignacion));
        const len2 = rep.length;
        for (let i = 0; i < len2; i++) {
            const d = rep[i].ordenes.sort((a, b) => a.asignado_a.localeCompare(b.asignado_a));
        }
        setreporteDias(rep);
    }

    const totales = (empleadoData) => {
        let dt = {
            dias_actividades: 0,
            sueldo_primer_turno: 0,
            turnos_1: 0,
            turnos_2: 0,
            bono: 0,
            num_ordenes: 0,
            tipo_empleado: {}
        }
        const fechas = Object.keys(empleadoData.fechas);
        fechas.forEach(fech => {
            const f = empleadoData.fechas[fech];
            dt.num_ordenes += f.ordenes.length;
            dt.tipo_empleado[f.contratista == 0 ? 'EMPLEAADO' : 'CONTRATISTA'] = true;
            dt.turnos_1 += f.nomina.primero;
            dt.turnos_2 += f.nomina.segundo;
            dt.bono += f.nomina.bono;
            dt.dias_actividades += (f.nomina.primero + f.nomina.segundo + f.nomina.bono) > 0 ? 1 : 0;
            dt.sueldo_primer_turno += f.nomina.pago_turno;
        });

        return { ...empleadoData, totales: dt };
    }

    const barraAvanceTurnos = (avance, nombre, helpText) => (
        <div className={`bw-100 p-0 ms-2 me-2`}>
            <div className="w text-s text-300" style={{ '--w': '100%' }}>{nombre}<span className='ms-1 text-xs text-bold'>{helpText}</span></div>
            <div className={`bw-100 round-xxl border text-start p-0 bg-black5`} style={{ overflow: "hidden" }}>
                <div className={`m-0 p-0`} style={{ minHeight: "4px", width: `${avance}%`, backgroundColor: colorPorcentaje(avance), transition: "width 1s ease-in-out", overflow: 'visible' }}></div>
            </div>
        </div>
    )

    const colorPorcentaje = (porcentaje) => {
        if (porcentaje < 20) return '#eb1f00ff';
        if (porcentaje < 45) return '#f09800ff';
        if (porcentaje < 90) return '#ded704ff';
        if (porcentaje < 100) return '#00ae06ff';
        return 'rgba(1, 102, 160, 1)';
    }

    const dibujarBarrasAvanceNomina = (nomina) => {
        return (<div className={`row d-flex m-0 p-0 justify-content-start w-100`}>
            {barraAvanceTurnos(nomina.primero * 100, '1º Turno', +((nomina.primero * 100).toFixed(3)) + '%')}
            {barraAvanceTurnos(nomina.segundo * 100, '2º Turno', +((nomina.segundo * 100).toFixed(3)) + '%')}
            {barraAvanceTurnos(nomina.bono > 0 ? 100 : 0, 'Bono:', '$' + +v.numberFormat(nomina.bono, 2).toFixed(2), '')}
        </div>)
    }

    return (
        <div className='supervisores-reporte-container w-100 dosis mt-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 120px)' }}>
            <div className='row justify-content-around w-100 m-0 p-0'>
                <table className='table table-sm table-borderless bw-1500  text-m' style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead style={indexDetalles === -1 ? { position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' } : {}}>
                        <tr>
                            <th scope='col'>DÍA</th>
                            <th scope='col' className='text-end pe-3 nowrap'>HRS.ASIGNADO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>HRS. REALIZADO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>UNI. ASIGNADAS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>UNI. REALIZADAS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>ORDENES TRAB.</th>
                            <th scope='col' className='text-end pe-3 nowrap'>EMPLEADOS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>SUPERVISORES</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reporteDias.map((sup, index) => {
                                const tdClass = "border-top pointer";
                                const opacity = indexDetalles === -1 || indexDetalles === index ? 100 : 30;
                                const cumplimiento = +(sup.horas_asignadas === 0 ? 0 : (sup.horas_realizadas / sup.horas_asignadas * 100).toFixed(2));
                                return (<React.Fragment key={index + "superv"}>
                                    <tr className={`opacity-${opacity}`} onClick={() => {
                                        if (indexDetalles === index) {
                                            setindexDetalles(-1);
                                        } else {
                                            setindexDetalles(index);
                                        }
                                    }}>
                                        <td scope='row' className={`bg-transparent text-bold ps-3 ${tdClass}`}>{dateFormatConDiaShort(sup.fecha_asignacion)}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{Math.round(sup.tiempo_asignado * 10) / 10}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{Math.round(sup.tiempo_realizado * 10) / 10}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{Math.round(sup.unidades_asignadas * 100) / 100}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{Math.round(sup.unidades_realizadas * 100) / 100}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.ordenes.length}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{Object.keys(sup.empleados).length}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{Object.keys(sup.supervisores).length}</td>
                                    </tr>
                                    {indexDetalles === index && <tr>
                                        <td colSpan={8} >
                                            <table className='table table-sm text-s table-hover'>
                                                <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                                                    <tr className='text-xs'>
                                                        <th>EMPLEADO</th>
                                                        <th>TIPO</th>
                                                        <th>SUPERVISOR</th>
                                                        <th>RANCHO</th>
                                                        <th>ÁREA</th>
                                                        <th>LABOR</th>
                                                        <th>ASIGNADO</th>
                                                        <th>REALIZADO</th>
                                                        <th>PORCENTAJE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sup.ordenes.map((ord, oIndex) => {
                                                        const avance = ord.unidades_asignadas != 0 ? Math.round(ord.unidades_realizadas / ord.unidades_asignadas * 10000) / 100 : 0;
                                                        return (
                                                            <tr key={oIndex + "superv" + index} style={{ fontSize: '12px' }}>
                                                                <td>{ord.asignado_a}</td>
                                                                <td>{ord.contratista === 1 ? "CONTRATISTA" : "EMPLEADO"}</td>
                                                                <td>{ord.asignado_por}</td>
                                                                <td>{ord.rancho_nombre}</td>
                                                                <td>{ord.area_nombre}</td>
                                                                <td>{ord.labor_nombre}</td>
                                                                <td>{ord.unidades_asignadas} <span className="text-xs">{ord.um_nombre}</span> / {+(ord.unidades_asignadas * ord.ms_por_unidad / 3600000).toFixed(3)} <span className="text-xxs">Hrs.</span></td>
                                                                <td>{ord.unidades_realizadas} <span className="text-xs">{ord.um_nombre}</span> / {+(ord.unidades_realizadas * ord.ms_por_unidad / 3600000).toFixed(3)} <span className="text-xxs">Hrs.</span></td>
                                                                <td>{avance}%</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table >

                                        </td>
                                    </tr>}
                                </React.Fragment>
                                )
                            })}
                    </tbody>
                </table>
                <div className='col-lg-12 mt-5 mb-5 p-5'></div>
            </div>
        </div>
    )
}

export default NominasPorDia;